import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

export class FlyttemeddelelseKvitteringFormBuilder {
    public static opretFormGroup(): UntypedFormGroup {
        return new UntypedFormBuilder().group({
            mailadresse: ["", [Validators.required, Validators.email]]
        });
    }
}
